module.exports = __webpack_public_path__ + "static/inspect-e9450112d5b4534d76ae64ca569f1b3f.mp4";